/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmory imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmory exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		Object.defineProperty(exports, name, {
/******/ 			configurable: false,
/******/ 			enumerable: true,
/******/ 			get: getter
/******/ 		});
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Not importing Openseadragon into the bundle, use global var instead
var $ = exports.$ = OpenSeadragon;

var DIRECTION_HORIZONTAL = exports.DIRECTION_HORIZONTAL = Symbol('horizontal');
var DIRECTION_VERTICAL = exports.DIRECTION_VERTICAL = Symbol('vertical');

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _globals = __webpack_require__(0);

var useStorage = false;
var STORAGE_ID = 'openseadragon-guides';

function addGuide(id, x, y, dir, rotation) {
  var direction = dir === _globals.DIRECTION_HORIZONTAL ? 'horizontal' : 'vertical';
  var guidesList = getGuides();
  // Check if guide with this id already exists
  var guide = guidesList.find(function (guide) {
    return guide.id === id;
  });

  // If guide exists update, otherwise create new one
  if (guide) {
    guide.x = x;
    guide.y = y;
    guide.rotation = rotation;
  } else {
    guidesList.push({ id: id, x: x, y: y, direction: direction, rotation: rotation });
  }

  saveData(guidesList);
}

function deleteGuide(id) {
  var guides = getGuides();

  saveData(guides.filter(function (guide) {
    return guide.id !== id;
  }));
}

function getGuides() {
  var data = window.sessionStorage.getItem(STORAGE_ID);

  if (data) {
    return JSON.parse(data);
  }

  return [];
}

function saveData(arr) {
  window.sessionStorage.setItem(STORAGE_ID, JSON.stringify(arr));
}

exports.default = {
  addGuide: addGuide,
  deleteGuide: deleteGuide,
  getGuides: getGuides,
  useStorage: useStorage
};

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Guide = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _globals = __webpack_require__(0);

var _session = __webpack_require__(1);

var _session2 = _interopRequireDefault(_session);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Guide = exports.Guide = function () {
  function Guide(_ref) {
    var clickHandler = _ref.clickHandler;
    var _ref$direction = _ref.direction;
    var direction = _ref$direction === undefined ? _globals.DIRECTION_HORIZONTAL : _ref$direction;
    var _ref$id = _ref.id;
    var id = _ref$id === undefined ? Date.now() : _ref$id;
    var plugin = _ref.plugin;
    var _ref$rotation = _ref.rotation;
    var rotation = _ref$rotation === undefined ? 0 : _ref$rotation;
    var viewer = _ref.viewer;
    var x = _ref.x;
    var y = _ref.y;

    _classCallCheck(this, Guide);

    this.viewer = viewer;
    this.plugin = plugin;
    this.direction = direction;
    this.rotation = rotation;
    this.id = id;

    // Center guide by default
    this.point = this.viewer.viewport.getCenter();
    this.point.x = x ? x : this.point.x;
    this.point.y = y ? y : this.point.y;

    this.elem = createElem(this.direction, this.id);
    this.line = createLine();
    this.elem.appendChild(this.line);
    this.overlay = new _globals.$.Overlay(this.elem, this.point);
    this.draw();

    // Store guide in session
    this.saveInStorage();

    if (clickHandler && this.plugin.allowRotation) {
      this.clickHandler = clickHandler;
    }

    if (this.plugin.allowRotation) {
      this.rotate(this.rotation);
    }

    this.addHandlers();
  }

  _createClass(Guide, [{
    key: 'addHandlers',
    value: function addHandlers() {
      // Listen for mouse events on the guide
      this.tracker = new _globals.$.MouseTracker({
        element: this.elem,
        clickTimeThreshold: this.viewer.clickTimeThreshold,
        clickDistThreshold: this.viewer.clickDistThreshold,
        dragHandler: this.dragHandler.bind(this),
        dragEndHandler: this.dragEndHandler.bind(this),
        dblClickHandler: this.remove.bind(this)
      });

      if (this.clickHandler) {
        this.tracker.clickHandler = this.clickHandler.bind(this);
      }

      // Redraw guide when viewer changes
      this.viewer.addHandler('open', this.draw.bind(this));
      this.viewer.addHandler('animation', this.draw.bind(this));
      this.viewer.addHandler('resize', this.draw.bind(this));
      this.viewer.addHandler('rotate', this.draw.bind(this));
    }
  }, {
    key: 'dragHandler',
    value: function dragHandler(event) {
      var delta = this.viewer.viewport.deltaPointsFromPixels(event.delta, true);

      switch (this.direction) {
        case _globals.DIRECTION_HORIZONTAL:
          this.point.y += delta.y;
          break;
        case _globals.DIRECTION_VERTICAL:
          this.point.x += delta.x;
          break;
      }

      this.elem.classList.add('osd-guide-drag');
      this.draw();
    }
  }, {
    key: 'dragEndHandler',
    value: function dragEndHandler() {
      this.elem.classList.remove('osd-guide-drag');
      this.saveInStorage();
    }
  }, {
    key: 'draw',
    value: function draw() {
      if (this.point) {
        this.overlay.update(this.point);
        this.overlay.drawHTML(this.viewer.drawer.container, this.viewer.viewport);
      }

      return this;
    }
  }, {
    key: 'remove',
    value: function remove() {
      this.viewer.removeHandler('open', this.draw.bind(this));
      this.viewer.removeHandler('animation', this.draw.bind(this));
      this.viewer.removeHandler('resize', this.draw.bind(this));
      this.viewer.removeHandler('rotate', this.draw.bind(this));

      this.overlay.destroy();
      this.point = null;

      _session2.default.deleteGuide(this.id);

      if (this.plugin.allowRotation) {
        this.plugin.closePopup();
      }

      return this;
    }
  }, {
    key: 'rotate',
    value: function rotate(deg) {
      if (parseFloat(deg)) {
        switch (this.direction) {
          case _globals.DIRECTION_HORIZONTAL:
            this.line.style.webkitTransform = 'rotateZ(' + deg + 'deg)';
            this.line.style.transform = 'rotateZ(' + deg + 'deg)';
            break;
          case _globals.DIRECTION_VERTICAL:
            this.line.style.webkitTransform = 'rotateZ(' + deg + 'deg)';
            this.line.style.transform = 'rotateZ(' + deg + 'deg)';
            break;
        }
        this.rotation = deg;
      } else {
        this.line.style.webkitTransform = '';
        this.line.style.transform = '';
        this.rotation = 0;
      }
      this.saveInStorage();
    }
  }, {
    key: 'saveInStorage',
    value: function saveInStorage() {
      if (_session2.default.useStorage) {
        _session2.default.addGuide(this.id, this.point.x, this.point.y, this.direction, this.rotation);
      }
    }
  }]);

  return Guide;
}();

function createElem(direction, id) {
  var elem = document.createElement('div');
  elem.id = 'osd-guide-' + id;
  elem.classList.add('osd-guide');

  switch (direction) {
    case _globals.DIRECTION_HORIZONTAL:
      elem.classList.add('osd-guide-horizontal');
      break;
    case _globals.DIRECTION_VERTICAL:
      elem.classList.add('osd-guide-vertical');
      break;
    default:
      throw new Error('Invalid guide direction');
  }

  return elem;
}

function createLine() {
  var lineElem = document.createElement('div');
  lineElem.classList.add('osd-guide-line');
  return lineElem;
}

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _guide = __webpack_require__(2);

var _globals = __webpack_require__(0);

var _session = __webpack_require__(1);

var _session2 = _interopRequireDefault(_session);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (!_globals.$.version || _globals.$.version.major < 2) {
  throw new Error('This version of OpenSeadragon Guides requires OpenSeadragon version 2.0.0+');
}

_globals.$.Viewer.prototype.guides = function (options) {
  if (!this.guidesInstance || options) {
    options = options || {};
    options.viewer = this;
    this.guidesInstance = new _globals.$.Guides(options);
  }

  return this.guidesInstance;
};

_globals.$.Guides = function (options) {
  var _this = this;

  _globals.$.extend(true, this, {
    // internal state properties
    viewer: null,
    guides: [],

    // options
    allowRotation: false,
    horizontalGuideButton: null,
    verticalGuideButton: null,
    prefixUrl: null,
    removeOnClose: false,
    useSessionStorage: false,
    navImages: {
      guideHorizontal: {
        REST: 'guidehorizontal_rest.png',
        GROUP: 'guidehorizontal_grouphover.png',
        HOVER: 'guidehorizontal_hover.png',
        DOWN: 'guidehorizontal_pressed.png'
      },
      guideVertical: {
        REST: 'guidevertical_rest.png',
        GROUP: 'guidevertical_grouphover.png',
        HOVER: 'guidevertical_hover.png',
        DOWN: 'guidevertical_pressed.png'
      }
    }
  }, options);

  _globals.$.extend(true, this.navImages, this.viewer.navImages);

  var prefix = this.prefixUrl || this.viewer.prefixUrl || '';
  var useGroup = this.viewer.buttons && this.viewer.buttons.buttons;
  var anyButton = useGroup ? this.viewer.buttons.buttons[0] : null;
  var onFocus = anyButton ? anyButton.onFocus : null;
  var onBlur = anyButton ? anyButton.onBlur : null;

  this.horizontalGuideButton = new _globals.$.Button({
    element: this.horizontalGuideButton ? _globals.$.getElement(this.horizontalGuideButton) : null,
    clickTimeThreshold: this.viewer.clickTimeThreshold,
    clickDistThreshold: this.viewer.clickDistThreshold,
    tooltip: _globals.$.getString('Tooltips.HorizontalGuide') || 'Horizontal guide',
    srcRest: prefix + this.navImages.guideHorizontal.REST,
    srcGroup: prefix + this.navImages.guideHorizontal.GROUP,
    srcHover: prefix + this.navImages.guideHorizontal.HOVER,
    srcDown: prefix + this.navImages.guideHorizontal.DOWN,
    onRelease: this.createHorizontalGuide.bind(this),
    onFocus: onFocus,
    onBlur: onBlur
  });

  this.verticalGuideButton = new _globals.$.Button({
    element: this.verticalGuideButton ? _globals.$.getElement(this.verticalGuideButton) : null,
    clickTimeThreshold: this.viewer.clickTimeThreshold,
    clickDistThreshold: this.viewer.clickDistThreshold,
    tooltip: _globals.$.getString('Tooltips.VerticalGuide') || 'vertical guide',
    srcRest: prefix + this.navImages.guideVertical.REST,
    srcGroup: prefix + this.navImages.guideVertical.GROUP,
    srcHover: prefix + this.navImages.guideVertical.HOVER,
    srcDown: prefix + this.navImages.guideVertical.DOWN,
    onRelease: this.createVerticalGuide.bind(this),
    onFocus: onFocus,
    onBlur: onBlur
  });

  if (useGroup) {
    this.viewer.buttons.buttons.push(this.horizontalGuideButton);
    this.viewer.buttons.element.appendChild(this.horizontalGuideButton.element);
    this.viewer.buttons.buttons.push(this.verticalGuideButton);
    this.viewer.buttons.element.appendChild(this.verticalGuideButton.element);
  }

  // Store globally so it can be used in the Guide objects
  _session2.default.useStorage = this.useSessionStorage;

  // Check if any guides are stored in sessionStorage
  if (_session2.default.useStorage) {
    var guides = _session2.default.getGuides();

    guides.forEach(function (guide) {
      var g = new _guide.Guide({
        viewer: _this.viewer,
        direction: guide.direction === 'horizontal' ? _globals.DIRECTION_HORIZONTAL : _globals.DIRECTION_VERTICAL,
        rotation: guide.rotation,
        id: guide.id,
        clickHandler: function clickHandler() {
          return _this.showPopup(g);
        },
        plugin: _this,
        x: guide.x,
        y: guide.y
      });

      _this.guides.push(g);
    });
  }

  // Remove guides when viewer closes
  if (this.removeOnClose) {
    this.viewer.addHandler('close', function () {
      _this.guides.forEach(function (guide) {
        return guide.remove();
      });
      _this.guides = [];
    });
  }

  if (this.allowRotation) {
    this.popup = this.createRotationPopup();
    this.viewer.addControl(this.popup, {});
    this.popup.style.display = 'none'; //add Controll sets display:block
    this.popupInput = this.popup.querySelector('input');
  }
};

_globals.$.extend(_globals.$.Guides.prototype, {
  createHorizontalGuide: function createHorizontalGuide() {
    var _this2 = this;

    var guide = new _guide.Guide({
      viewer: this.viewer,
      plugin: this,
      direction: _globals.DIRECTION_HORIZONTAL,
      clickHandler: function clickHandler() {
        return _this2.showPopup(guide);
      }
    });
    this.guides.push(guide);
  },
  createVerticalGuide: function createVerticalGuide() {
    var _this3 = this;

    var guide = new _guide.Guide({
      viewer: this.viewer,
      plugin: this,
      direction: _globals.DIRECTION_VERTICAL,
      clickHandler: function clickHandler() {
        return _this3.showPopup(guide);
      }
    });
    this.guides.push(guide);
  },
  showPopup: function showPopup(guide) {
    this.popup.style.display = 'block';
    this.selectedGuide = guide;
    this.popupInput.value = this.selectedGuide.rotation;
  },
  closePopup: function closePopup() {
    this.popup.style.display = 'none';
    this.popupInput.value = '';
    this.selectedGuide = null;
  },


  // TODO: Refactor popup into new class
  createRotationPopup: function createRotationPopup() {
    var _this4 = this;

    var popup = document.createElement('div');
    popup.id = 'osd-guide-popup';
    popup.classList.add('osd-guide-popup');
    popup.style.position = 'absolute';
    popup.style.bottom = '10px';
    popup.style.left = '10px';

    var form = document.createElement('form');
    form.classList.add('osd-guide-popup-form');
    form.style.display = 'block';
    form.style.position = 'relative';
    form.style.background = '#fff';
    form.style.padding = '10px';

    popup.appendChild(form);

    var input = document.createElement('input');
    input.type = 'text';
    input.style.display = 'inline-block';
    input.style.width = '50px';
    input.style.fontSize = '14px';
    form.appendChild(input);

    var rotateButton = document.createElement('button');
    rotateButton.type = 'submit';
    rotateButton.innerHTML = _globals.$.getString('Tool.rotate') || 'rotate';
    rotateButton.style.fontSize = '14px';
    rotateButton.classList.add('osd-guide-rotate-button');

    rotateButton.addEventListener('click', function () {
      _this4.selectedGuide.rotate(input.value);
      _this4.closePopup();
    });

    form.appendChild(rotateButton);

    var closeButton = document.createElement('button');
    closeButton.innerHTML = '&times;';
    closeButton.title = _globals.$.getString('Tool.close') || 'close';
    closeButton.style.fontWeight = 'bold';
    closeButton.style.fontSize = '14px';
    closeButton.classList.add('osd-guide-close');
    closeButton.addEventListener('click', function () {
      _this4.closePopup();
    });
    form.appendChild(closeButton);

    return popup;
  }
});

/***/ }
/******/ ]);


// WEBPACK FOOTER //
// openseadragon-guides.js